import { render, staticRenderFns } from "./Whitelist.vue?vue&type=template&id=5b6d9e56&scoped=true&"
import script from "./Whitelist.vue?vue&type=script&lang=js&"
export * from "./Whitelist.vue?vue&type=script&lang=js&"
import style0 from "./Whitelist.vue?vue&type=style&index=0&id=5b6d9e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d9e56",
  null
  
)

export default component.exports